import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { mapClinicalTopicToContentDetails } from 'src/mappers/models/clinicalTopicMapper';

import { LoginFormFields } from 'src/components/account/Login/LoginFormFields';

import { ClinicalTopic } from './_ContentDetailTypes/_ClinicalTopic';

// import { mapCPDArticleToContentDetails } from 'src/mappers/models/cpdArticleMapper';
// import { mapLearningModuleToContentDetails } from 'src/mappers/models/learningModuleMapper';
import ContentDetailFields from './ContentDetailFields';

// import { CPDArticle } from './_ContentDetailTypes/_CPDArticle';
// import { LearningModule } from './_ContentDetailTypes/_LearningModule';
// import { ResourcePage } from './_ContentDetailTypes/_ResourcePage';

type ContentDetailProps = ComponentProps & {
	fields: ContentDetailFields & LoginFormFields;
};

export default withDatasourceCheck()<ContentDetailProps>(ContentDetail);

function ContentDetail(props: ContentDetailProps): JSX.Element {
	function clinicalTopic() {
		const clinicalTopic = mapClinicalTopicToContentDetails(
			props.rendering.uid ?? '',
			props.rendering.fields,
			props.fields.WildCardContentUrl
		);
		return clinicalTopic ? <ClinicalTopic ContentDetail={clinicalTopic} fields={props.fields} /> : <></>;
	}

	// function cpdArticle() {
	// 	const cpdArticle = mapCPDArticleToContentDetails(
	// 		props.rendering.uid ?? '',
	// 		props.rendering.fields,
	// 		props.fields.RCNiSAMLIdPBaseUrl,
	// 		props.fields.RCNiMPSSSORelayStateParameterName,
	// 		props.fields.RCNiMPSSSOSpentityId,
	// 		props.fields.RCNiMPSSSOSpentityIdParameterName
	// 	);
	// 	return cpdArticle ? <CPDArticle ContentDetail={cpdArticle} fields={props.fields} /> : <></>;
	// }

	// function learningModule() {
	// 	const learningModule = mapLearningModuleToContentDetails(
	// 		props.rendering.uid ?? '',
	// 		props.rendering.fields,
	// 		props.fields.RCNiSAMLIdPBaseUrl,
	// 		props.fields.RCNiImpelsysSSORelayStateParameterName,
	// 		props.fields.RCNiImpelsysSSOSpentityId,
	// 		props.fields.RCNiImpelsysSSOSpentityIdParameterName
	// 	);
	// 	return learningModule ? <LearningModule ContentDetail={learningModule} fields={props.fields} /> : <></>;
	// }

	function determineContentComponent() {
		switch (`${props.fields.WildCardContentTemplateId?.toLowerCase()}`) {
			case sitecoreIds.Templates.ClinicalTopicLandingPageTemplateId.toLowerCase():
			case sitecoreIds.Templates.ClinicalTopicContentPageTemplateId.toLowerCase():
				return clinicalTopic();
			case sitecoreIds.Templates.ResourcePageTemplateId.toLowerCase():
				return <></>;
			case sitecoreIds.Templates.RCNiCPDArticleTemplateId.toLowerCase():
				return <></>;
			case sitecoreIds.Templates.RCNiLearningModuleTemplateId.toLowerCase():
				return <></>;
			default:
				console.error(
					`Unsupported Content Type passed to ContentDetail component. It's TemplateId was ${props.fields.WildCardContentTemplateId}`
				);
				return <></>;
		}
	}

	return <section>{determineContentComponent()}</section>;
}
